@if (questionForm) {
  <rt-interview-base-box
    [question]="questionForm.getRawValue()"
    [formGroup]="questionForm"
    [rtProtectedControl]="questionForm.controls.content"
    [invalid]="
      questionForm.controls.content.invalid &&
      (questionForm.dirty || questionForm.touched) &&
      formSubmissionAttempt
    "
    [errorMessage]="errorMessage"
  >
    @switch (questionForm.value.questionKind) {
      @case (QuestionKind.String) {
        <rt-input
          [placeholder]="placeholder | translate"
          formControlName="content"
          variant="rounded"
        >
        </rt-input>
      }
      @case (QuestionKind.Text) {
        <rt-textarea
          [autoHeight]="true"
          formControlName="content"
          [placeholder]="placeholder | translate"
        >
        </rt-textarea>
      }
    }
  </rt-interview-base-box>
}
